import Header from "../Header";
import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";
import {submitStep} from '../../network';
import ReactGA from 'react-ga';


const Welcome = ({nextStep, currentFormStep, maxStep}) => {
    useEffect(() => {
        ReactGA.pageview(window.location.pathname + "/welcome");
    }, []);
    const [isLoading, setLoading] = useState(false);
    const onSubmit = data => {
        setLoading(true)
        submitStep("welcome", data)
            .then(() => {
                setLoading(false);
                nextStep()
            });
    };
    const {register, handleSubmit, errors} = useForm();
    return (<>
        <Header title="Tere tulemast programmeerimise algkursusele!"/>
        <progress className="progress is-link" value={currentFormStep} max={maxStep}/>
        <section className="section">
            <div className="container">
                <h1 className="title">
                    Tere, hea tudeng!
                </h1>
                <figure className="image video-container">
                    <iframe className="has-ratio video-iframe"
                            src="https://www.youtube.com/embed/HXfmANk_16Y?showinfo=0" frameborder="0"
                            allowfullscreen></iframe>
                </figure>
                <p className="text">
                    Programmeerimise algkursusel (ITI0102) saad selgeks, mis on programmeerimine ja kuidas kirjutada
                    programmeerimiskeeles Python erinevaid programme.
                </p>
                <p className="text">
                    Ole hea, aita meid sellega, et võtad 20-25 minutit aega ja mõtled meiega kaasa.
                    Järgnevatel slaididel on olulist infot aine kohta ning mõned küsimused, mille vastused on meile
                    huvitavad ja olulised aine ettevalmistamisel.
                </p>
                <p className="text">
                    Kui saad, ole hea, kasuta oma tegelikku ees- ja perekonnanime ja vasta julgelt ja otsekoheselt -
                    siis saan selge pildi Su vajadustest ja tean aidata, kui seda peaks vaja minema. Siin pole ükski
                    vastus vale!<br/>
                </p>
                <p className="text">
                    <strong>NB! Su vastuseid nimega seotuna näen vaid mina, vastutav õppejõud Ago Luberg.</strong><br/>
                    Üldistatud andmeid jagan ka aine abiõppejõududega, et ka nemad saaksid teid kõiki paremini toetada.
                </p>
                <p className="text">
                    <strong>Ago Luberg</strong><br/>
                    Aine eest vastutav õppejõud ja informaatika õppekava programmijuht
                </p>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="container">
                <div className="control">
                    <h1 className="subtitle form-question">
                        Mis on Sinu nimi?
                    </h1>
                    <input name="fullName" ref={register({required: true})} className="input half-width-input"
                           type="text"
                           placeholder="Sinu ees- ja perekonnanimi"/>
                    <h1 className="subtitle form-question">
                        Mis õppekaval Sa õpid?
                    </h1>
                    <div className="select">
                        <select name="studyProgramme" ref={register({required: true})}>
                            <option value="" selected disabled>Vali</option>
                            <option value="IAAB">IAAB</option>
                            <option value="IADB daytime">IADB päevaõpe</option>
                            <option value="IADB session-based">IADB sessioonõpe</option>
                            <option value="IAIB">IAIB</option>
                            <option value="microdegree">Mikrokraad</option>
                            <option value="Open studies">Avatud ülikool</option>
                            <option value="Other">Muu eriala</option>
                        </select>
                    </div>
                    {Object.keys(errors).length ? <div className="validation-error">
                        Jätkamiseks vasta palun kõigile küsimustele!
                    </div> : null}
                </div>
                <button className={`button is-large is-rounded take-test-button ${isLoading ? 'is-loading' : ''}`}
                        disabled={isLoading}>JÄRGMINE →
                </button>
            </form>
        </section>
    </>);
};

export default Welcome;
